import React from 'react';

export interface SurfaceCardProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  /** Left accent stripe (logs-style). Default true. */
  accent?: boolean;
  /** Top accent line on hover. */
  interactive?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const SurfaceCard: React.FC<SurfaceCardProps> = ({
  children,
  className = '',
  contentClassName = '',
  accent = true,
  interactive = false,
  disabled = false,
  onClick,
}) => {
  const rootClass = [
    'wday-surface-card',
    interactive && !disabled ? 'wday-surface-card--interactive' : '',
    disabled ? 'wday-surface-card--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={rootClass}
      onClick={disabled ? undefined : onClick}
      role={onClick && !disabled ? 'button' : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={
        onClick && !disabled
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick(event as unknown as React.MouseEvent<HTMLDivElement>);
              }
            }
          : undefined
      }
    >
      <div className="wday-surface-card__bg" aria-hidden />
      <div className="wday-surface-card__overlay" aria-hidden />
      {accent && <div className="wday-surface-card__accent" aria-hidden />}
      {interactive && !disabled && <div className="wday-surface-card__top-accent" aria-hidden />}
      <div className={['wday-surface-card__content', contentClassName].filter(Boolean).join(' ')}>
        {children}
      </div>
    </div>
  );
};

export default SurfaceCard;
